import { useQuery } from 'react-query';

import axios from 'axios';
import { apiLambda, getToken } from '../services/apiLambda';

const baseHost = process.env.REACT_APP_DEBTS_QUERY_HOST;
const basePath = '/debts';
const consultsPackagePath = '/consults/package';
const consultsPackageStatusPath = '/consults/package/status';

export interface IVehicleInfo {
  id: number;
  sub: string;
  nickname: string;
  idVehicle: number;
  document: string;
  uf?: string;
  renavam?: string;
  chassi?: string;
  vehicleType?: string;
  showNotification: true;
  isSpecial: false;
  fipe?: string;
  created_at: '2023-10-08T13:14:52.000Z';
  updated_at: '2023-10-08T13:14:52.000Z';
  deleted_at?: string;
  vehicle: {
    id: number;
    placa: string;
    renavam: string;
    uf: string;
    municipio: string;
    chassi: string;
    tipo: string;
    marca: string;
    ano: number;
    importado: boolean;
    invalid: boolean;
    licensingStatus: string;
    licensingExpirationDate: string;
    lastLicensed?: number;
    lastIPVA?: any;
    lastMultaConsult?: any;
    licensingPaymentDate?: any;
    created_at: '2022-04-07T12:20:24.000Z';
    updated_at: '2023-08-07T10:00:33.000Z';
    deleted_at?: string;
  };
  hasCrlvCoolDown?: false;
}

interface IConsultsPackageDTO {
  userVehicleId: number;
  firstConsult: boolean;
  origin: string;
}

interface IConsultsFailed {
  id: number;
  reason: string;
  userVehicleId: number;
  userVehicle: IVehicleInfo;
  consultsPackageId: number;
}
export interface IConsultsPackage {
  id: number;
  userSub: string;
  quantity: number;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  logConsultsFailed?: IConsultsFailed[];
  success: number;
  failed?: number;
}

interface IPagedParams {
  resultsPerPage?: number;
  page?: number;
  plate?: string;
  orderBy?: string;
  orderByDirection?: string;
}
export interface IGetPagedResult {
  vehicles: IVehicleInfo[];
  // nPages: number;
  // total: number;
  // resultsPerPage: string;
  // currentPage: string;
}

export async function listVehicleInfo(
  params: IPagedParams,
): Promise<IGetPagedResult> {
  const { data } = await apiLambda.get(basePath);

  const { vehicles } = data?.data || [];

  return {
    vehicles,
  };
}

export async function consultDebtsToUpdateInfo(
  userVehicleId: number,
  firstConsult = false,
): Promise<any> {
  const token = getToken();
  const { data } = await axios.post(
    baseHost ?? '',
    { userVehicleId, firstConsult, origin: 'frotas' },
    {
      headers: {
        'Request-Environment': 'frotas',
        terminal: process.env.REACT_APP_TERMINAL,
        authorization: `Bearer ${token}`,
      },
    },
  );

  return data;
}

export async function postConsultsPackage(
  packageData: IConsultsPackageDTO[],
): Promise<IConsultsPackage> {
  const { data } = await apiLambda.post(consultsPackagePath, {
    listToConsult: packageData,
  });

  return data.data;
}

export async function getStatusConsultsPackage(): Promise<IConsultsPackage[]> {
  const { data } = await apiLambda.get(consultsPackageStatusPath);

  return data.data;
}

export async function createItemVehicleInfo(
  dataObject: IVehicleInfo,
): Promise<any> {
  const { data } = await apiLambda.post(basePath, dataObject);

  return data;
}

export async function getItemVehicleInfoById(id: number): Promise<any> {
  const { data } = await apiLambda.get(`${basePath}/${id}`);

  return data;
}

export async function deleteItemVehicleInfo(id: number): Promise<any> {
  const { data } = await apiLambda.delete(`${basePath}/${id}`);

  return data;
}

export function useVehicleInfo(params: IPagedParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    basePath,
    params.orderByDirection,
    params.orderBy,
    params.plate,
    params.page,
    params.resultsPerPage,
  ];

  return useQuery(queryKey, () => listVehicleInfo(params), {
    staleTime: 60000,
  });
}
